import DeliveryChoiceTabs from './DeliveryChoiceTabs';

export default DeliveryChoiceTabs;
